module.exports = __webpack_public_path__ + "static/media/id_terceros.01e262b7.xlsx";